module.exports = __webpack_public_path__ + "img/badge-4k-fill.189e8ea9.svg";